import { Flex } from "orcs-design-system";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import FteBadge from "src/components/TeamDetailPage/FteBadge";
import { useAuth0 } from "src/contexts/auth0Provider";
import {
  useAllocationProject,
  useUserPerson,
} from "src/contexts/global/GlobalContext";
import { useWorkspace } from "src/contexts/global/WorkspaceContext";
import { ModalProvider } from "src/contexts/withModal";
import TeamMembersPanel from "src/pages/TeamPage/sub-components/TeamMembersPanel";

import withTeam from "../DataProviderHOCs/withTeam";

const CanvTeamDescription = withTeam(({ team }) => {
  const userPerson = useUserPerson();
  const workspace = useWorkspace();
  const { user } = useAuth0();
  const allocationProject = useAllocationProject();

  const renderMemberFteBadge = useMemo(() => {
    return (member, memberInTeam) => (
      <FteBadge workspace={workspace} member={member} team={memberInTeam} />
    );
  }, [workspace]);

  return (
    <ModalProvider>
      <Flex alignItems="center" flexWrap="wrap" gap="r">
        <TeamMembersPanel
          key="team-members-panel"
          teamId={team.id}
          team={team}
          workspace={workspace}
          allocationProject={allocationProject}
          user={user}
          userPerson={userPerson}
          renderFteBadge={renderMemberFteBadge}
        />
      </Flex>
    </ModalProvider>
  );
});

CanvTeamDescription.propTypes = {
  channel: PropTypes.string.isRequired,
};

export default CanvTeamDescription;
